import { gql } from "@apollo/client";
import { PROFILE_ENTITY_FIELDS } from "graphql/fragments";

const GET_MEMBER_FEEDBACK_FOR_TEAM = gql`
  ${PROFILE_ENTITY_FIELDS}
  query memberFeedbackForTeam($teamId: ID!, $filters: MemberFeedbackForTeamFilter) {
    memberFeedbackForTeam(teamId: $teamId, filters: $filters) {
      profile {
        ...ProfileEntityFields
      }
      answer
      month
      monthVerbose
      question
      sentiment
      sentimentScore
    }
  }
`;

export { GET_MEMBER_FEEDBACK_FOR_TEAM };
